import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { ref, set, onValue, update, get, push } from 'firebase/database';

function AddSubject() {
  const [boardType, setBoardType] = useState('');
  const [year, setYear] = useState('');
  const [className, setClassName] = useState('');
  const [division, setDivision] = useState('');
  const [subject, setSubject] = useState('');
  const [savedSubjects, setSavedSubjects] = useState([]);
  const udiseNo = localStorage.getItem('udiseNumber');
  const language = localStorage.getItem('language');

  const years = ['2020-2021','2021-2022','2022-2023','2023-2024', '2024-2025','2025-2026','2026-2027','2027-2028','2028-2029','2029-2030','2030-2031','2031-2032','2032-2033','2033-2034','2034-2035','2035-2036'];


   const [classes, setClasses] = useState([]); // To hold class names
   const [divisions, setDivisions] = useState([]);
    
    const fetchClassDivData = () => {
      const storedDivClasses = localStorage.getItem("classDiv");
    if (storedDivClasses) {
      const data = JSON.parse(storedDivClasses);
      const classList = [];
      const divisionList = {};
      for (const [className, value] of Object.entries(data)) {
        if (value === true) {
          classList.push(className);
          divisionList[className] = [];
        } else if (typeof value === 'object') {
          classList.push(className);
          divisionList[className] = Object.keys(value).filter(div => value[div]);
        }
      }
      // console.log("divisionList",divisionList);
      
      setClasses(classList);
      setDivisions(divisionList);
    };}

      const openIndexedDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('SchoolManagementDB', 1); // Use your actual DB name and version

      request.onerror = (event) => {
        console.error("IndexedDB error:", event.target.error);
        reject("Error opening IndexedDB");
      };

      request.onsuccess = (event) => {
        resolve(event.target.result);
      };

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('studentData')) {
          db.createObjectStore('studentData', { keyPath: 'id' });
        }
      };
    });
  };
    const fetchSchoolData = async () => {
    if (udiseNo) {
      try {
        const db = await openIndexedDB();
        const transaction = db.transaction(['schoolData'], 'readonly');
        const objectStore = transaction.objectStore('schoolData');
        const request = objectStore.get(udiseNo);

        request.onsuccess = (event) => {
          const data = event.target.result;
          if (data  && data.boardType) {
              setBoardType(data.boardType); 
          }
        };

        request.onerror = (event) => {
          console.error("Error fetching school data:", event.target.error);
        };
      } catch (error) {
        console.error('Error fetching school data:', error);
      }
    }
  };
      useEffect(() => {
        fetchSchoolData()
        fetchClassDivData();
      }, [year, udiseNo]);

      useEffect(() => {
        const fetchSubjects = () => {
          let subjectsRefPath;
      
          if (boardType === 'icse') {
            if (!division) return; // Ensure division is set for ICSE
            subjectsRefPath = `schoolRegister/${udiseNo}/subjectSequence/icse/${year}/${className}/${division}`;
          } else {
            subjectsRefPath = `schoolRegister/${udiseNo}/subjectSequence/${year}/${className}`;
          }
      
          // console.log("Fetching subjects from path:", subjectsRefPath); // Debugging
      
          const subjectsRef = ref(db, subjectsRefPath);
          const unsubscribe = onValue(subjectsRef, (snapshot) => {
            const data = snapshot.val();
            // console.log("Fetched data:", data); // Debugging
            if (data) {
              const subjectsArray = Object.entries(data).map(([key, value]) => ({ id: key, name: value }));
              setSavedSubjects(subjectsArray);
            } else {
              setSavedSubjects([]);
            }
          });
      
          return () => unsubscribe();
        };
      
        if (year && className && boardType) {
          fetchSubjects();
        }
      }, [year, className, boardType, division]);
  const handleSaveSubject = async () => {
    if (!year || !className || !subject.trim() || (boardType === 'icse' && !division)) {
      alert('Please fill in all fields.');
      return;
    }
  
    const subjectName = subject.trim();
    const path =
      boardType === 'icse'
        ? `schoolRegister/${udiseNo}/subjectSequence/icse/${year}/${className}/${division}`
        : `schoolRegister/${udiseNo}/subjectSequence/${year}/${className}`;
  
    const subjectsRef = ref(db, path);
    try {
      const snapshot = await get(subjectsRef);
      const existingData = snapshot.val() || {};
      const existingSubjects = Object.entries(existingData).map(([key, value]) => ({ id: key, name: value }));
  
      // Check if the subject already exists
      if (existingSubjects.some(existingSubject => existingSubject.name === subjectName)) {
        alert('This subject already exists.');
        return;
      }

      // console.log("existingSubjects", existingSubjects);

      // Determine the next ID
      const nextId = existingSubjects.length > 0 
        ? Math.max(...existingSubjects.map(sub => parseInt(sub.id, 10) || 0)) + 1 
        : 1;
  
      // console.log("nextId:", nextId);
  
      // Save the new subject with the next ID
      await set(ref(db, `${path}/${nextId}`), subjectName);
      setSubject(''); // Clear the input field
    } catch (error) {
      console.error('Error saving subject:', error);
    }
  };
// ?
  const containerStyle = {
    padding: '30px',
    maxWidth: '700px',
    margin: 'auto',
    fontFamily: 'Segoe UI, sans-serif',
    backgroundColor: '#f9f9f9',
    borderRadius: '12px',
    boxShadow: '0 0 10px rgba(0,0,0,0.1)'
  };

  const formGroupStyle = {
    marginBottom: '20px',
  };

  const labelStyle = {
    display: 'block',
    marginBottom: '8px',
    fontWeight: '600',
    fontSize: '15px',
  };

  const inputStyle = {
    width: '100%',
    padding: '10px',
    borderRadius: '5px',
    border: '1px solid #ccc',
    fontSize: '14px',
  };

  const buttonStyle = {
    padding: '10px 20px',
    fontSize: '15px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    marginTop: '10px'
  };

  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '30px',
  };

  const thTdStyle = {
    border: '1px solid #ccc',
    padding: '10px',
    textAlign: 'left',
    fontSize: '14px',
  };

  const headingStyle = {
    textAlign: 'center',
    marginBottom: '30px',
    color: '#333'
  };

  return (
    <div className="main-content-of-page">
    <div style={containerStyle}>
      
      <h3  style={{ color:'#03365e', fontWeight:'600', textAlign:'center'}}>{language==="English"? "Add Subject": "विषय भरा"}</h3>
      

      <div style={formGroupStyle}>
        <label style={labelStyle}>{language==="English"? "Year": "वर्ष"} :</label>
        <select value={year} onChange={(e) => setYear(e.target.value)} style={inputStyle}>
          <option value="">{language==="English"? "Select Year": "वर्ष निवडा"}  </option>
          {years.map((yearOption) => (
            <option key={yearOption} value={yearOption}>{yearOption}</option>
          ))}
        </select>
      </div>

      <div style={formGroupStyle}>
        <label style={labelStyle}>{language==="English"? "Class": "वर्ग"} :</label>
        <select value={className} onChange={(e) => setClassName(e.target.value)} style={inputStyle}>
          <option value="">{language==="English"? "Select Class": "वर्ग निवडा"} </option>
          {classes.map((classOption) => (
            <option key={classOption} value={classOption}>{classOption}</option>
          ))}
        </select>
      </div>
      {boardType === 'icse' && (
  <div style={formGroupStyle}>
    <label style={labelStyle}>{language === "English" ? "Division" : "तुकडी"} :</label>
    <select value={division} onChange={(e) => setDivision(e.target.value)} style={inputStyle}>
      <option value="">{language === "English" ? "Select Division" : "तुकडी निवडा"} </option>
      {divisions[className] && divisions[className].map((divisionOption) => (
        <option key={divisionOption} value={divisionOption}>{divisionOption}</option>
      ))}
    </select>
  </div>
)}

      <div style={formGroupStyle}>
        <label style={labelStyle}>{language==="English"? "Subject": "विषय"} :</label>
        <input
          type="text"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          style={inputStyle}
        />
      </div>

      <button onClick={handleSaveSubject} style={buttonStyle}>Save</button>

      <h3 style={{ marginTop: '40px', color: '#333' }}>{language==="English"? "All Subjects": "सर्व विषय"} </h3>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={{...thTdStyle, fontWeight:'bold'}}>ID </th>
            <th style={{...thTdStyle, fontWeight:'bold'}}>{language==="English"? "Subject": "विषय"} </th>
          </tr>
        </thead>
        <tbody>
        {savedSubjects.map((savedSubject, index) => (
    <tr key={index}>
      <td style={thTdStyle}>{index + 1}</td> {/* Display serial number */}
      <td style={thTdStyle}>{savedSubject.name}</td>
    </tr>
  ))}
        </tbody>
      </table>
    </div>
    </div>
  );
}

export default AddSubject;
